import { PatientBookingHistoryItem } from '../models/patient-booking-history-item.model';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EmergencyContact } from '../models/emergency-contact.model';
import { MedicalRecord } from '../models/patient-medical-record';
import { Patient } from '../models/patient.model';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  private apiUrl = environment.APP_BASE_URL + '/doctor-portal/patient-view';
  private patientFileEndpoint = environment.APP_BASE_URL + '/doctor-portal/patient-view/patient-file';

  public createPatientFile(patient: Patient, clinicMembershipId?: string): Observable<Patient> {
    const headers: Record<string, string> = {};
    if (clinicMembershipId) {
      headers['X-Clinic-Membership-Id'] = clinicMembershipId;
    }
    return this.http.post<Patient>(this.patientFileEndpoint, patient, { headers });
  }

  public getPatientById(patientId: string): Observable<Patient> {
    return this.http.get<Patient>(`${this.patientFileEndpoint}/${patientId}/details`);
  }

  public updatePatientFile(patientId: string, patient: Patient): Observable<Patient> {
    return this.http.put<Patient>(`${this.patientFileEndpoint}/${patientId}`, patient);
  }

  constructor(private http: HttpClient) { }

  public getPatientBookingHistory(patientId: string): Observable<PatientBookingHistoryItem[]> {
    return this.http.get<PatientBookingHistoryItem[]>(
      `${this.apiUrl}/patient-file/${patientId}/booking-history`,
    );
  }

  public getEmergencyContact(bookingId: string | undefined): Observable<EmergencyContact> {
    return this.http.get<EmergencyContact>(`${this.apiUrl}/emergency/${bookingId}`);
  }

  public getEmergencyContactByPatientId(patientId: string): Observable<EmergencyContact> {
    return this.http.get<EmergencyContact>(`${this.apiUrl}/emergency/patient/${patientId}`);
  }

  public createEmergencyContact(
    patientId: string,
    contact: EmergencyContact,
  ): Observable<EmergencyContact> {
    return this.http.post<EmergencyContact>(
      `${this.apiUrl}/emergency-contact/${patientId}`,
      contact,
    );
  }

  public getDoctorPatients(): Observable<Patient[]> {
    return this.http.get<Patient[]>(`${this.apiUrl}/patients`);
  }

  public getPatientMedicalRecords(patientId: string | undefined): Observable<MedicalRecord[]> {
    return this.http.get<MedicalRecord[]>(`${this.apiUrl}/medical-records/${patientId}`);
  }

  public downloadPatientFile(patientId: string | undefined): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/patient-file/${patientId}`, {
      responseType: 'blob',
    });
  }

  public deactivatePatient(patientId: string): Observable<any> {
    return this.http.put(`${this.patientFileEndpoint}/${patientId}/deactivate`, {});
  }

  public getPatientByCode(patientCode: string | null | undefined): Observable<Patient> {
    return this.http.get<Patient>(`${this.apiUrl}/patient/${patientCode}`);
  }
}
